import { useState, useCallback } from 'react';
import { EmailData } from '@shared/types/email';
import { graphService } from '../services/graphService';
import { addinLogger } from '../utils/addinLogger';

export const useEmail = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const getCurrentEmail = useCallback(async (): Promise<EmailData> => {
    return new Promise((resolve, reject) => {
      addinLogger.info('getCurrentEmail: starting');
      setLoading(true);
      setError(null);

      const item = Office.context.mailbox.item;
      if (!item) {
        addinLogger.error('getCurrentEmail: no mailbox item', 'Office.context.mailbox.item is null');
        const err = new Error('No email item available');
        setError(err);
        setLoading(false);
        reject(err);
        return;
      }

      item.body.getAsync(
        Office.CoercionType.Text,
        (result: Office.AsyncResult<string>) => {
          if (result.status === Office.AsyncResultStatus.Failed) {
            const msg = result.error?.message || 'Failed to get email body';
            addinLogger.error('getCurrentEmail: body.getAsync failed', msg);
            const err = new Error(msg);
            setError(err);
            setLoading(false);
            reject(err);
            return;
          }

          addinLogger.debug('getCurrentEmail: body.getAsync ok, converting itemId');
          const currentItem = Office.context.mailbox.item;
          if (!currentItem) {
            addinLogger.error('getCurrentEmail: item gone after getAsync');
            const err = new Error('No email item available');
            setError(err);
            setLoading(false);
            reject(err);
            return;
          }

          const itemId = Office.context.mailbox.convertToRestId(
            currentItem.itemId,
            Office.MailboxEnums.RestVersion.v2_0
          );
          addinLogger.info('getCurrentEmail: calling Graph API', `itemId=${itemId?.slice(0, 30)}...`);

          graphService
            .getEmail(itemId)
            .then((emailData) => {
              addinLogger.info('getCurrentEmail: success', `subject=${emailData?.subject?.slice(0, 40) ?? 'n/a'}`);
              setLoading(false);
              resolve(emailData);
            })
            .catch((err) => {
              addinLogger.error('getCurrentEmail: Graph getEmail failed', err?.message ?? String(err));
              setError(err);
              setLoading(false);
              reject(err);
            });
        }
      );
    });
  }, []);

  return {
    getCurrentEmail,
    loading,
    error,
  };
};





